import type { ReactNode } from 'react';
import { ChatProvider } from './ChatProvider/ChatProvider';
import { ErrorProvider } from './ErrorProvider/ErrorProvider';
import { AuthProvider } from './AuthProvider/AuthProvider';
import { ColorModeProvider } from './ColorModeProvider/ColorModeProvider';
import { CompanyProvider } from './CompanyProvider/CompanyProvider';
import { JobsProvider } from './JobsProvider/JobsProvider';
import { LocationsProvider } from './LocationsProvider/LocationsProvider';
import { NewJobProvider } from './NewJobProvider/NewJobProvider';
import { RepairersProvider } from './RepairersProvider/RepairersProvider';
import { NotificationsProvider } from './NotificationsProvider/NotificationsProvider';

export const AppProviders = ({ children }: { children: ReactNode }) => (
    <ErrorProvider>
        <AuthProvider>
            <ColorModeProvider>
                <NotificationsProvider>
                    <CompanyProvider>
                        <LocationsProvider>
                            <RepairersProvider>
                                <ChatProvider>
                                    <JobsProvider>
                                        <NewJobProvider>{children}</NewJobProvider>
                                    </JobsProvider>
                                </ChatProvider>
                            </RepairersProvider>
                        </LocationsProvider>
                    </CompanyProvider>
                </NotificationsProvider>
            </ColorModeProvider>
        </AuthProvider>
    </ErrorProvider>
);
